import { tabletMatchMedia } from './utility';

export default function navigationClose() {
  if (!tabletMatchMedia.matches) {
    return;
  }

  const closeTriggers = document.querySelectorAll('.js-close-menu-and-accordion');

  closeTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('closeAccordions'));
      document.dispatchEvent(new CustomEvent('closeNavigationMenu'));
    });
  });
}
